import React, { useContext, useMemo } from "react";
import { navigate } from "gatsby";

import { StructuredTextRenderer } from "../../../../components/StructuredTextRenderer";
import { Button } from "../../../../components/Button";
import { TeaserCard } from "../../../../components/teaser-components/TeaserCard/TeaserCard";

import t from "../../../../lib/translate";

import * as styles from "./CameraTeaserElement.module.less";
import GeneralPageContext from "../../../../templates/GeneralPageContext";

export function CameraTeaserElement(
    {
        data: {
            id,
            url,
            name,
            isNew = false,
            linkText,
            image,
            cameraCategory = [],
            cameraImageFormat = [],
            detectorType,
            price,
            priceInfoText,
            priceLink,
            originalId
        },
        semanticOfTeaserHeadline,
        currency
    },
    hasLightBackground
) {
    const {
        stdPages: { pageFovCalculator }
    } = useContext(GeneralPageContext);

    const CameraTeaserFooterContent = (
        <>
            <Button
                type={"secondary"}
                iconPosition={"left"}
                icon={"imageFieldCalculator"}
                className={styles.fovButton}
                to={`${pageFovCalculator.url}?fovCameraId=${originalId}`}
                renderAs="link"
            >
                {t("camera.item.fov-calculator")}
            </Button>

            {price && (
                <span className={styles.price}>{`${price} ${currency}`}</span>
            )}

            {priceInfoText?.value && (
                <StructuredTextRenderer
                    className={styles.infoText}
                    data={priceInfoText}
                    contentElementType={"CameraTeaserElement"}
                />
            )}

            <StructuredTextRenderer
                itemLinkType={"cta"}
                itemLinkIconPosition={"left"}
                data={priceLink}
                contentElementType={"CameraAccessoryTeaserElement"}
                itemLinkClass={styles.priceLink}
                itemLinkState={{ selectedItemId: id }}
            />
        </>
    );

    const imageFormat = useMemo(() => {
        const [, readableFormat] = cameraImageFormat.reduce(
            (prev, { irX, irY, imageFormat }) => {
                const pixelAmount = irX * irY;

                if (pixelAmount > prev[0]) {
                    return [pixelAmount, imageFormat];
                }

                return prev;
            },
            [0, "0 x 0"]
        );

        return readableFormat;
    }, []);

    return (
        <div className={styles.teaserCardWrapper}>
            <TeaserCard
                teaserData={{
                    image,
                    tagline: cameraCategory
                        ? cameraCategory.map(({ name }) => name).join(", ")
                        : undefined,
                    headline: name,
                    semanticOfHeadline: semanticOfTeaserHeadline,
                    url,
                    link: linkText || t("camera.item.default-link-text")
                }}
                isNew={isNew}
                hasLightBackground={hasLightBackground}
                FixedContent={CameraTeaserFooterContent}
                cameraId={id}
            >
                {(detectorType || cameraImageFormat) && (
                    <table className={styles.formats}>
                        <tbody>
                            {imageFormat && (
                                <tr>
                                    <td>{t("camera.item.image-format")}</td>
                                    <td>
                                        {t("camera.item.image-format.value", [
                                            imageFormat
                                        ])}
                                    </td>
                                </tr>
                            )}

                            {detectorType && (
                                <tr>
                                    <td>{t("camera.item.detector-type")}</td>
                                    <td>{detectorType}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </TeaserCard>
        </div>
    );
}
